import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown, MoreHorizontal } from "lucide-react";

export const ActionMenu = ({
  align = "end",
  dataTestId,
  iconOnly = false,
  items = [],
  triggerLabel = "Actions",
}) => {
  const visibleItems = items.filter(Boolean);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          className={iconOnly ? "secondary-button compact-button action-menu-trigger icon-only" : "secondary-button compact-button action-menu-trigger"}
          data-testid={dataTestId}
          type="button"
          variant="outline"
        >
          {iconOnly ? <MoreHorizontal size={16} /> : <><span>{triggerLabel}</span><ChevronDown size={16} /></>}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align} className="vlq-dropdown-content" data-testid={dataTestId ? `${dataTestId}-content` : undefined}>
        {visibleItems.map((item) => (
          <DropdownMenuItem
            className={item.destructive ? "vlq-dropdown-item destructive" : "vlq-dropdown-item"}
            data-testid={item.testId}
            disabled={item.disabled}
            key={item.testId || item.label}
            onSelect={item.onSelect}
          >
            {item.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};